/**
 * Warning: this is copy pasted from:
 * https://github.com/chordcommerce/chord-ui/blob/6ad68d2949bff588298f81a3720df7bc095b6eb1/packages/gatsby-starter-autonomy/src/utils/chord/serialize.js
 *
 */

/**
 * Serializes a Kit into a Product for react-autonomy methods.
 *
 * @param {any} product
 * @param {string | undefined} kitSku
 * @param {{url: string, locationDetail: string}} additionalProperties
 * @returns {import('@chordcommerce/react-autonomy').Product}
 */
export const serializeKit = (
  product = {},
  kitSku = undefined,
  additionalProperties = { url: '', locationDetail: '' }
) => {
  const mainImage = product.mainImage?.gatsbyImageData?.images?.fallback?.src;
  const sku = kitSku ? kitSku : serializeKitSkuFromProducts(product.products);

  return {
    id: product.id,
    imageUrl: mainImage,
    productId: product.slug,
    name: product.name,
    slug: product.slug,
    isBundle: true,
    shortDescription: product.shortDescription,
    variant: {
      imageUrl: mainImage,
      images: [
        {
          largeUrl: mainImage,
        },
      ],
      name: product.name,
      price: product.price,
      sku,
      slug: product.slug,
    },
    ...additionalProperties,
  };
};

/**
 * Serializes an application Product into a Product for react-autonomy methods.
 *
 * @param {any} product
 * @param {string | undefined} variantSku
 * @param {{url: string, locationDetail: string}} additionalProperties
 * @returns {import('@chordcommerce/react-autonomy').Product}
 */
export const serializeProduct = (product = {}, variantSku, additionalProperties = { url: '', locationDetail: '' }) => {
  const mainImage = product.mainImage?.gatsbyImageData?.images?.fallback?.src;
  const variant = variantSku ? product.variants?.find(({ sku }) => sku === variantSku) : product.variants?.[0];
  const variantImage = variant?.mainImage?.gatsbyImageData?.images?.fallback?.src;

  const options = variant?.optionValues.map((value) => {
    return {
      name: value.name,
      presentation: value.presentation,
      slug: value.slug,
      optionType: value.option_type,
    };
  });

  return {
    imageUrl: mainImage,
    name: product.name,
    slug: product.slug,
    productId: product.slug,
    isBundle: false,
    shortDescription: product.shortDescription,
    variant: {
      imageUrl: variantImage || mainImage,
      images: [
        {
          largeUrl: variantImage || mainImage,
        },
      ],
      name: variantSku ? variant?.name ?? product.name : product.name, // this overrides the product name
      description: variant?.description ?? product.shortDescription,
      price: variant?.price ?? product.price,
      sku: variant?.sku ?? variantSku,
      slug: product.slug,
      optionValues: options,
    },
    ...additionalProperties,
  };
};

/**
 * Serializes an application Product or Kit into a Product for react-autonomy
 * methods.
 *
 * @param {any} product
 * @param {string | undefined | null} sku
 * @param {{url: string, locationDetail: string}=} additionalProperties
 * @returns {import('@chordcommerce/react-autonomy').Product}
 */
export const serializeProductOrKit = (product, sku, additionalProperties) => {
  return product?.products
    ? serializeKit(product, sku, additionalProperties)
    : serializeProduct(product, sku, additionalProperties);
};

export const serializeKitSkuFromProducts = (products) => {
  const skus = products.map((product) => product.variants[0].sku);
  return skus.sort().join('|');
};
